import { create as createCache } from "@/lib/simpleCache";
const weekDateCache = createCache();
import moment from "moment-timezone";

const summarize = momentDate => {
	return {
		unixTimestamp: momentDate.unix(),
		// Mon, Tue, etc.
		dayAbbreviation: momentDate.format( "ddd" ),
		dayOfMonth: momentDate.date(),
		dayOfWeek: momentDate.day(),
		// "2020-04-20"
		shortFormat: momentDate.format( "YYYY-MM-DD" ),
		// "Monday, April 20"
		longFormat: momentDate.format( "dddd, MMMM D" ),
		isoFormat: momentDate.format(),
	};
};

/**
 * @param {Moment} targetDate
 * @param {Boolean} [forceRecache] = false
 * @returns {Array.<WeekDay>}
 */
export const calculateWeekdays = ( targetDate, forceRecache = false ) => {
	// only ever need to run this calculation once
	// per date
	const shortDateFormat = targetDate.format( "YYYY-MM-DD" );
	return weekDateCache.set(
		shortDateFormat,
		() => {
			targetDate = moment( shortDateFormat );
			const targetWeek = targetDate.week();
			const weekDates = [ summarize( targetDate ), ];

			let yesterday = targetDate
				.clone()
				.subtract( 1, "days" )
				.startOf( "day" );
			let previousWeek = yesterday.week();

			while ( previousWeek === targetWeek ) {
				weekDates.unshift( summarize( yesterday ) );
				yesterday = yesterday
					.clone()
					.subtract( 1, "days" )
					.startOf( "day" );
				previousWeek = yesterday.week();
			}

			let tomorrow = targetDate
				.clone()
				.add( 1, "days" )
				.startOf( "day" );
			let nextWeek = tomorrow.week();

			while ( nextWeek === targetWeek ) {
				weekDates.push( summarize( tomorrow ) );
				tomorrow = tomorrow
					.clone()
					.add( 1, "days" )
					.startOf( "day" );
				nextWeek = tomorrow.week();
			}

			return weekDates;
		},
		forceRecache );
};



// WEBPACK FOOTER //
// ./src/lib/weekDays.js